var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('main',{staticClass:"main",attrs:{"id":"contents"}},[_c(_setup.PpvConfirm),_c(_setup.PpvToast),_c(_setup.WCampaign,{attrs:{"campaign":_setup.campaignData}}),(_setup.catalogData)?_c(_setup.WCatalog,{attrs:{"id":_setup.id,"catalog":_setup.catalogData}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }